module.exports = __webpack_public_path__ + "static/media/vacation-for-yourself.bef29a22.png";